import React from "react";
import HighchartsReact from "highcharts-react-official";
import Highcharts from "@/utils/highcharts";
import "./ChartBlock.scss";

const ChartBlock = ({ highchartsConfig, block_id, section_id, report_id }) => (
    <div
        className="chart-block"
        id={block_id || undefined}
        data-block-id={block_id || undefined}
        data-section-id={section_id || undefined}
        data-report-id={report_id || undefined}
    >
        <HighchartsReact
            highcharts={Highcharts}
            options={{
                ...highchartsConfig,
                exporting: { enabled: true }
            }}
        />
    </div>
);

export default ChartBlock;
